import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { onActionKey } from '../../utils';
import './_styles_/EmailsTabs.css';

export const TEMPLATES_TAB = 'templates';
export const LOGS_TAB = 'logs';

EmailsTabs.propTypes = {
    activeTab: PropTypes.string.isRequired,
    onTabChange: PropTypes.func.isRequired,
};

function EmailsTabs(props) {
    const {
        activeTab,
        onTabChange,
    } = props;
    const { t } = useTranslation();
    const tabs = [
        { key: TEMPLATES_TAB, label: t('emails.tab.templates') },
        { key: LOGS_TAB, label: t('emails.tab.logs') },
    ];
    return (
        <div className="emails-tabs" role="tablist">
            {tabs.map((tab) => {
                const isActive = tab.key === activeTab;
                const className = isActive ? 'emails-tabs--tab emails-tabs--tab-active' : 'emails-tabs--tab';
                return (
                    <div
                        key={tab.key}
                        role="tab"
                        tabIndex={0}
                        aria-selected={isActive}
                        className={className}
                        onClick={() => onTabChange(tab.key)}
                        onKeyDown={onActionKey(() => onTabChange(tab.key))}
                    >
                        {tab.label}
                    </div>
                );
            })}
        </div>
    );
}

export default EmailsTabs;
